 const userInfo = {
	state: { 
        storecode:'',
        storename:'', 
        repertorycode:'',
        repertoryname:'', 
        user_code: '',
        user_name: ""
	},
	getters:{
        usershow(state){//这里的state对应着上面这个state
            return state;
        }
    },
	mutations:{
		SWITCHSHOW(state,msg){
		console.log("mutations内1"+JSON.stringify(state));
		console.log("mutations内"+JSON.stringify(msg));
            state.storecode = msg.storecode;
            state.storename = msg.storename;
            state.repertorycode = msg.repertorycode;
            state.repertoryname = msg.repertoryname;
            state.user_code = msg.user_code;
            state.user_name = msg.user_name;
		console.log("mutations内2"+JSON.stringify(state));
		}
	},
	actions: {
		switchshow(context, msg){
            context.commit('SWITCHSHOW1', msg)
		}	}
};		
export default userInfo



// WEBPACK FOOTER //
// ./src/store/userInfo.js